export const NOT_SET = Symbol('NOT_SET');
export const X_TOKEN_HEADER_NAME = 'X-Token';
export const AXIOS_CANCELLED_CODE = 'ERR_CANCELED';
export const LOGO_PATH = '/logo.svg';
export const SMALL_LOGO_PATH = '/logo-small.jpeg';
export const BACKGROUND_IMG_PATH = '/freelancer_bg.jpg';
export const ACCESS_TOKEN = 'accessToken';
export const ENTITY_QUERY_PARAM = 'entity';